import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import * as api from "../../services/api";


export const usePricesCoverageQuery = (enabled, fromISODate, toISODate) => {
    return useQuery({
        queryKey: ["rms", "pricesCoverage", fromISODate, toISODate],
        queryFn: () => api.RatesAPI.getPricesCoverage(fromISODate, toISODate),
        enabled: enabled
    });
}

export const useAbitAccountsQuery = () => {
    return useQuery({
        queryKey: ["abitAccounts"],
        queryFn: () => api.AbitAccounts.getAllAbitAccount(),
    })
}

export const useAbitAccountCreateMutation = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (data) => await api.AbitAccounts.createAbitAccount(data),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ["abitAccounts"]});
        }
    });
}

export const useAbitAccountUpdateMutation = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ({id, ...data}) => await api.AbitAccounts.updateAbitAccount(id, data),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ["abitAccounts"]});
        }
    });
}

export const useAbitAccountDestroyMutation = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (id) => await api.AbitAccounts.deleteAbitAccount(id),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ["abitAccounts"]});
        }
    });
}

export const useAlloggiatiAccountsQuery = () => {
    return useQuery({
        queryKey: ["alloggiatiAccounts"],
        queryFn: () => api.AlloggiatiAccounts.getAllAlloggiatiAccount(),
    })
}

export const useAlloggiatiAccountCreateMutation = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (data) => await api.AlloggiatiAccounts.createAlloggiatiAccount(data),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ["alloggiatiAccounts"]});
        }
    });
}

export const useAlloggiatiAccountUpdateMutation = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ({id, ...data}) => await api.AlloggiatiAccounts.updateAlloggiatiAccount(id, data),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ["alloggiatiAccounts"]});
        }
    });
}

export const useAlloggiatiAccountDestroyMutation = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (id) => await api.AlloggiatiAccounts.deleteAlloggiatiAccount(id),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ["alloggiatiAccounts"]});
        }
    });
}